import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faBolt, faRocket, faStar } from '@fortawesome/free-solid-svg-icons';
import './HomePage.css';
import { useNavigate } from 'react-router-dom';
import CompanyLogos from '../CompanyLogos/CompanyLogos';
import TestimonialCard from '../TestimonialCard/TestimonialCard';
const HomePage = () => {
    const navigate = useNavigate();
    const goToPracticeNow = () => {
        navigate('/interview-questions'); // Navigate to the interview questions page
    };
    const goToPremium = () => {
        navigate('/premium'); // Navigate to premium page
    };

    const positions = [
        'Software Engineer', 'Consultant', 'Business Analyst', 'Data Scientist', 'Product Manager',
        'Audit Associate', 'Program Manager', 'Data Analyst', 'Project Manager', 'Technology Analyst',
        'Human Resources', 'Account Manager', 'Quantitative Analyst', 'Java Developer', 'Customer Service',
        'Financial Analyst', 'Operations Analyst', 'Process Engineer', 'Investment Analyst', 'Solutions Architect',
        'Tax Associate', 'Business Development', 'Backend Developer', 'Vice President', 'Cloud Support',
        'Hardware Engineer', 'Technical Support', 'Market Manager', 'UX Designer', 'Brand Specialist'
    ];

    const cardsData = [
        {
            company: 'Meta',
            position: 'Software Engineer',
            questionType: 'Technical',
            question: 'What is the difference between C and C++?'
        },
        {
            company: 'Google',
            position: 'Data Scientist',
            questionType: 'Situational',
            question: 'How to remove bias and make inference from data about two ad campaigns in AB testing?'
        },
        {
            company: 'IBM',
            position: 'Project Manager',
            questionType: 'Behavioral',
            question: 'Tell me about a project you are very proud of.'
        },
        {
            company: 'J.P. Morgan',
            position: 'Operations',
            questionType: 'Cultural',
            question: 'What animal is most representative of you and your personality?'
        }
    ];


    return (
        <div className="home-page">
            <div className="first-content">
                <div class="first-content-inner">
                    <div className="upper-text">
                        <h2 className="upper-heading">Boost Interview with AI</h2>
                        <p className="new-text">Practice interviews with real questions from top companies and receive expert AI guidance to land your dream job.</p>
                        <button className="practice-now-btn" onClick={goToPracticeNow}>Free Practice Now</button>
                    </div>
                    <section className="home-content">
                        <header className="home-header">
                            <h1>Practice More, Interview Easier</h1>
                        </header>
                        <div className="feature">
                            <div className="feature-title">
                                <FontAwesomeIcon icon={faListAlt} className="feature-icon list-alt" />
                                <h2>Top Questions</h2>
                            </div>
                            <p>Tackle 15000+ actual interview challenges from leading companies—curated from the last 3 years.</p>
                        </div>
                        <div className="feature">
                            <div className="feature-title">
                                <FontAwesomeIcon icon={faBolt} className="feature-icon bolt" />
                                <h2>AI-Powered Feedback</h2>
                            </div>
                            <p>Receive instant, AI-driven evaluations and response to sharpen your responses on the spot.</p>
                        </div>
                        <div className="feature">
                            <div className="feature-title">
                                <FontAwesomeIcon icon={faRocket} className="feature-icon rocket" />
                                <h2>Land Your Dream Job</h2>
                            </div>
                            <p>Boost your interview technique and get ready for the job offer you've been aiming for.</p>
                        </div>
                    </section>
                </div>
            </div>
            {/* Section for positions */}
            <div className="second-content">
                <div class="second-content-inner">
                    <div className="positions-text">
                        <h2>Prepare with interview questions previously appeared for 180+ popular positions.</h2>
                    </div>
                    <section className="positions-section">
                        {positions.map((position, index) => (
                            <div key={index} className="select-position-name">{position}</div>
                        ))}
                    </section>
                </div>
                <div class="second-content-bottom">
                    <div className="company-text">
                        <p>Included interview questions from 30+ companies</p>
                    </div>
                    <CompanyLogos />
                </div>
            </div>
            <div className="third-content">
                <div class="third-content-inner">
                    <div className="question-text">
                        <h2>Practice real interview questions from top companies and get instant AI-driven evaluations and enhanced response.</h2>
                    </div>
                </div>
                <div class="third-content-bottom">
                    <div className="left-content">
                        {cardsData.map((card, index) => (
                            <div key={index} className="interview-card">
                                <div className="card-header">
                                    <span className="company-names">{card.company}</span>
                                    <span className="position-names">{card.position}</span>
                                    <span className="question-types">{card.questionType}</span>
                                </div>
                                <div className="card-body">
                                    <p>{card.question}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="arrow-container">
                        <img src="./arrow_line.png" alt="Arrow Line" className="arrow-line" />
                    </div>
                    <div className="right-content">
                        <div className="question-example-container">
                            <img src="./question_example.png" alt="Question Example" className="rounded-image" />
                        </div>
                        <div className="feedback-container-h">
                            <div className="feedback-score-h">
                                <span className="feedback-message-h">Good job! Your response is on the right track.</span>
                                <div className="score-circle-h">70</div>
                            </div>
                            <div className="feedback-text-h">
                                <strong>Feedback:</strong>
                                <p>Your answer provides a solid foundation by outlining a relevant project and your role within it. However, it lacks specific details that could enrich the narrative and better demonstrate your competencies ...</p>
                            </div>
                            <div className="enhanced-response-h">
                                <strong>Enhanced Response:</strong>
                                <p>In my tenure with a burgeoning tech startup, I spearheaded a pivotal project to revolutionize our inventory management through the introduction of an automated software tool. This initiative was driven by ...</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="fourth-content">
                <div class="fourth-content-inner">
                    <div className="left-text">
                        <h2>Practice, Improve, Succeed!</h2>
                        <p>Embark on a journey of daily growth to sharpen your interview skills and unlock opportunities with your dream companies.</p>
                        <button className="try-practice-now-btn" onClick={goToPracticeNow}>Free Practice Now</button>
                    </div>
                    <div className="middle-image">
                        <img src="./rocket.png" alt="Rocket" />
                    </div>
                    <div className="right-text">
                        <h2>Invest in Yourself, It's Priceless!</h2>
                        <p>Unlock premium features to accelerate your path to success and secure your dream job. Your future self will thank you.</p>
                        <button className="try-premium-now-btn" onClick={goToPremium}>
                            <FontAwesomeIcon icon={faStar} className="premium-star" />
                            Try Premium Now
                        </button>
                    </div>
                </div>
            </div>
            <div className="fifth-content">
                <div class="fifth-content-inner">
                    <div className="left-comment">
                        <h2>Loved by Candidates Across All Industries</h2>
                    </div>
                    <div className="right-image">
                        <img src="./celebration.png" alt="Celebration" />
                    </div>
                </div>
                <div class="fifth-content-bottom">
                    <TestimonialCard />
                </div>
            </div>
        </div>
    );
};

export default HomePage;
